// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bYtb","col":"styles_col__SCDcY"};